import PasswordRequirements from "./PasswordRequirements";
import BlockFailedLogins from "./BlockFailedLogins";
import PasswordlessLogin from "./PasswordlessLogin";
import LoginWith2FA from './LoginWith2FA';
import ViolatedItems from "./ViolatedItems";
import NoPolicies from "./NoPolicies";

const policiesComponents = {
  PasswordRequirements,
  BlockFailedLogins,
  PasswordlessLogin,
  LoginWith2FA,
  ViolatedItems,
  NoPolicies
};

export default policiesComponents